import { Button } from '@sunwebgroup/uds-ui/button'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { useSetPasswordActions } from '@/scopes/auth/infrastructure/setPasswordDependencies'
import { AuthConfirmationLayout } from '../AuthConfirmationLayout'
import styles from './SetPasswordMessage.module.css'

export function SetPasswordConfirmation() {
  const intl = useIntl()
  const { loginPageRequested } = useSetPasswordActions()

  return (
    <AuthConfirmationLayout
      icon="CheckMarkInCircle"
      title={intl.formatMessage({ id: 'auth_set_password_confirmation_heading' })}
      showSpamNote={false}
    >
      <Typography as="p" variant="body-m-regular-snug" className={styles.message}>
        {intl.formatMessage({ id: 'auth_set_password_confirmation_message' })}
      </Typography>
      <Button type="button" variant="primary" fullWidth onClick={loginPageRequested}>
        {intl.formatMessage({ id: 'auth_set_password_sign_in_label' })}
      </Button>
    </AuthConfirmationLayout>
  )
}
